import computerCheck from '#app/assets/images/computer-check.svg'
import arrows from '#app/assets/images/shuffle.svg'
import multipleUsers from '#app/assets/images/user-multiple.svg'
import { TechCard } from './components/TechCard'

const cardsInfo = [
	{
		title: 'Adaptación',
		description:
			'Posibilidad de ofrecer productos a la medida de los clientes.',
		icon: <img src={arrows} alt="" />,
	},
	{
		title: 'Operación Digital',
		description:
			'Agiliza los procesos operativos para brindar una mejor experiencia.',
		icon: <img src={computerCheck} alt="" />,
	},
	{
		title: 'Presencia',
		description:
			'Estar donde tus clientes están desde el canal más importante: el digital.',
		icon: <img src={multipleUsers} alt="" />,
	},
]

export default function IndustryDigitalizationSection() {
	return (
		<section
			style={{
				backgroundImage: 'url(/img/bg-lines.png)',
				backgroundSize: 'contain',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
			}}
			className="mx-auto max-w-[1400px] pt-[64px] pr-[20px] pb-[60px] pl-[20px] md:pt-[120px] md:pr-[120px] md:pb-[120px] md:pl-[120px]"
		>
			<div className="mb-[38px] flex w-full justify-center px-[30px] md:mb-[64px] md:px-0">
				<h1 className="text-center text-[32px] leading-[45px] font-medium text-blue-800 md:w-[60%] md:text-[56px] md:leading-[70px]">
					La digitalización para la industria aseguradora
				</h1>
			</div>

			<div className="flex flex-col gap-7 md:flex-row">
				{cardsInfo.map((card, index) => (
					<TechCard
						icon={card.icon}
						key={index}
						title={card.title}
						description={card.description}
					></TechCard>
				))}
			</div>
		</section>
	)
}
